import { ChangeEventWorkflow } from "src/generated/graphqlTypes";
import { GuidedChangeEventStep } from "src/routes/projects/change-events/guided/utils";
import {
  reviewImpactStep,
  reviewStep,
} from "src/routes/projects/change-events/guided/workflows/sharedSteps/sharedSteps";
import { defineWorkflow } from "src/routes/projects/change-events/guided/workflows/types";
import { SelectConfigurationStep } from "../1.SelectConfigurationStep";
import { ReviewConfigurationStep } from "../2.ReviewConfigurationStep";
import {
  applyConfigurationFormConfig,
  ApplyConfigurationFormInput,
  applyConfigurationMapToForm,
} from "../applyConfigurationForm";
import { useApplyConfigurationActions } from "../useSaveApplyConfigurationChangeEvent";

export const applyPartialConfigurationWorkflow = defineWorkflow<ApplyConfigurationFormInput>({
  workflow: ChangeEventWorkflow.ApplyPartialConfiguration,
  formConfig: applyConfigurationFormConfig,
  mapToForm: applyConfigurationMapToForm,
  steps: [
    {
      value: GuidedChangeEventStep.SelectConfiguration,
      label: "Select New Config",
      isComplete: (form) => !!form.targetConfigId.value && form.optionIds.valid,
      render: (form, project) => <SelectConfigurationStep formState={form} project={project} />,
    },
    {
      value: GuidedChangeEventStep.ReviewConfiguration,
      label: "Review New Config",
      isComplete: (form) => !!form.targetConfigId.value,
      disabled: (form) => !form.targetConfigId.value,
      render: (form) => <ReviewConfigurationStep formState={form} />,
    },
    reviewImpactStep(),
    reviewStep(),
  ],
  useActions: useApplyConfigurationActions,
});
